module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-shaded-32cfe8e9.svg";